/*!
 * lh-card-swipe.js
 * Mobile swipe carousel for all product cards on Logan Hollowell.
 *
 * Behaviour:
 *   - Only activates on touch devices (hover:none / pointer:coarse).
 *   - Swipe left/right → advance slides.
 *   - Tap without dragging → navigate to the product page.
 *   - Dot pagination updated on every slide change.
 *   - Re-initialises after Shopify section:load events (theme editor / AJAX).
 */
(function () {
  'use strict';

  // Use pointer:coarse rather than hover:none — more reliable across Android
  // browsers (Chrome, Samsung Internet) which may report hover:hover even on
  // phones, causing carousel to be skipped entirely.
  var TOUCH_MQ = window.matchMedia('(pointer: coarse)');

  function initCarousel(el) {
    if (el.dataset.lhSwipeInit) return;
    el.dataset.lhSwipeInit = '1';

    var track  = el.querySelector('.lh-card-swipe__track');
    var dots   = el.querySelectorAll('.lh-card-swipe__dot');
    var slides = el.querySelectorAll('.lh-card-swipe__slide');
    var href   = el.dataset.href;
    var count  = slides.length;

    if (!track || count < 2) return;

    var current  = 0;
    var startX   = 0;
    var hasMoved = false;

    function goTo(idx) {
      current = ((idx % count) + count) % count;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('lh-card-swipe__dot--active', i === current);
      });
    }

    el.addEventListener('touchstart', function (e) {
      startX   = e.touches[0].clientX;
      hasMoved = false;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 8) {
        hasMoved = true;
      }
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;

      if (!hasMoved) {
        // Pure tap — navigate to product.
        // Mirror Stiletto's onClickedToLeave: activate the page-transition
        // overlay first, then navigate after 200 ms.  This closes the iOS
        // cross-page ghost-click window (the new page hasn't loaded yet when
        // the ghost click fires) and keeps the departure animation consistent.
        if (href) {
          e.preventDefault();
          var overlay = document.getElementById('page-transition-overlay');
          if (overlay) overlay.classList.add('active');
          setTimeout(function () { window.location.href = href; }, 200);
        }
        return;
      }

      if (Math.abs(dx) > 35) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }

      hasMoved = false;
    });
  }

  function initAll() {
    // Also fall back to ontouchstart for browsers where the MQ still misfires
    if (!TOUCH_MQ.matches && !('ontouchstart' in window)) return;
    document.querySelectorAll('.lh-card-swipe').forEach(initCarousel);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme editor / AJAX section loads
  document.addEventListener('shopify:section:load', initAll);

  // Expose for manual calls after AJAX product injection
  window.lhInitCardSwipe = initAll;
})();
